import $ from 'jquery';
$('.slider__row').slick({
    dots: false,
    infinite: true,
    autoplay: true, 
    autoplaySpeed: 6000,
    arrows: true,
    swipeToSlide: true,
    slidesToShow: 1,
    prevArrow: "<img class='slick-prev pull-left' src='/wp-content/themes/atlas/assets/gfx/arr.png' alt='arrow' />",
    nextArrow: "<img class='slick-next pull-right' src='/wp-content/themes/atlas/assets/gfx/arr.png' alt='arrow' />",
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint:920,
        settings: {
          arrows:false,
          dots:true,
        }
      }
    ]
});   
 
  $(".slider__row")
    .on("beforeChange", function(event, slick, currentSlide, nextSlide) {
      $(".slick-list").addClass("do-tans");
  })
    .on("afterChange", function() {
      $(".slick-list").removeClass("do-tans");
  });

$('.kor__slider__').slick({
    dots: false,
    infinite: true,
    autoplay: true, 
    autoplaySpeed: 6000,
    arrows: true,
    swipeToSlide: true,
    slidesToShow:1,
    centerMode: true,
    centerPadding: '20%',
    prevArrow: "<img class='slick-prev pull-left' src='/wp-content/themes/atlas/assets/gfx/arr.png' alt='arrow' />",
    nextArrow: "<img class='slick-next pull-right' src='/wp-content/themes/atlas/assets/gfx/arr.png' alt='arrow' />",
    responsive: [
        {
          breakpoint:1500,
          settings: {
            centerPadding: '10%',
          }
        },
        {
          breakpoint:720,
          settings: {
            centerPadding: '0%',
          }
        }
      ]
});   




$(document).ready(function() {
  if ($(window).width() < 960) {
    
 }else {
    
 
  const slider = $('.kor__slider');
  
  function onSliderAfterChange(event, slick, currentSlide) {
    $('.kor__slide--i').removeClass('big');
    $(event.target).data('current-slide', currentSlide);
  }
  
  function onSliderWheel(e) {
    var deltaY = e.originalEvent.deltaY,
      $currentSlider = $(e.currentTarget),
      currentSlickIndex = $currentSlider.data('current-slide') || 0;
    
    if (
      // check when you scroll up
      (deltaY < 0 && currentSlickIndex == 0) ||
      // check when you scroll down
      (deltaY > 0 && currentSlickIndex == $currentSlider.data('slider-length') - 1)
    ) {
      return;
    }

    e.preventDefault();

    if (e.originalEvent.deltaY < 0) {
      $currentSlider.slick('slickPrev');
    } else {
      $currentSlider.slick('slickNext');
    }
  }
  
  slider.each(function(index, element) {
    var $element = $(element);
    // set the length of children in each loop
    // but the better way for performance is to set this data attribute on the div.slider in the markup
    $element.data('slider-length', $element.children().length);
  })
  .slick({
    dots: false,
    infinite: true,
    autoplay: true, 
    autoplaySpeed: 6000,
    arrows: true,
    swipeToSlide: true,
    slidesToShow:1,
    centerMode: true,
    centerPadding: '20%',
    prevArrow: "<img class='slick-prev pull-left' src='/wp-content/themes/atlas/assets/gfx/arr.png' alt='arrow' />",
    nextArrow: "<img class='slick-next pull-right' src='/wp-content/themes/atlas/assets/gfx/arr.png' alt='arrow' />",
    responsive: [
        {
          breakpoint:1500,
          settings: {
            centerPadding: '10%',
          }
        },
        {
          breakpoint:920,
          settings: {
            // centerPadding: '0%',
            unslick : true,
          }
        }
      ]
  })
  .on('afterChange', onSliderAfterChange)
  .on('wheel', onSliderWheel);
}
});




$('.kor__slide--i').each(function(){
  $(this).on('click tap', function(){
    $(this).toggleClass('big');
  })
});








$('.reko__slider').slick({
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: true,
    swipeToSlide: true,
    slidesToShow:1,
    centerMode: true,
    centerPadding: '20%',
    prevArrow: "<img class='slick-prev pull-left' src='/wp-content/themes/atlas/assets/gfx/arr.png' alt='arrow' />",
    nextArrow: "<img class='slick-next pull-right' src='/wp-content/themes/atlas/assets/gfx/arr.png' alt='arrow' />",
    responsive: [
        {
          breakpoint:1500,
          settings: {
            centerPadding: '10%',
          }
        },
        {
          breakpoint:720,
          settings: {
            centerPadding: '0%',
          }
        }
      ]
});   

$('.next__wrapper .next__title').on('click',function(){
    $('.kor .slick-next').trigger('click');
});
    var nexttitle = $('.kor .slick-slide.slick-current').next().find('.kor__slide--title').text();
    $('.next__wrapper .next__title').text(nexttitle);
    $('.kor__slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
        var nexttitle = $('.kor .slick-slide.slick-current').next().find('.kor__slide--title').text();
        $('.next__wrapper .next__title').text(nexttitle);
    });
    

 
    